import { startTasks } from '@/utils/task.js'
import { blockEventListener } from '@/utils/eventListener.js'
import { sendErrorLog } from '@/utils/common.js'
import store from '@/store'

const state = {
    routeAction: 'push',
    noticeBindAddress: null, // 0:暂不提示；1:匹配正确；-1:匹配错误或未绑定
    platform: null,
    isinapp: false,
    loadOver: false,
    choseAddress: null,
    scanRes: null,
    fundvalue: null,
    fundmoney: null,
    totalsupply: null,
    totaldisp: null,
    intervalIds: null
}

const mutations = {
    SET_NOTIC_BIND(state, val) {
        state.noticeBindAddress = val
    },
    SET_FUNDVAL(state, val) {
        state.fundvalue = val
    },
    SET_FUNDMN(state, val) {
        state.fundmoney = val
    },
    SET_TOTALSUP(state, val) {
        state.totalsupply = val
    },
    SET_TOTALDISP(state, val) {
        state.totaldisp = val
    },
    SET_TASK_IDS(state, val) {
        state.intervalIds = val
    },
    SET_CHOSE(state, val) {
        state.choseAddress = val
    },
    SET_SCAN_RES(state, val) {
        state.scanRes = val
    },
    SET_PLATFORM(state, val) {
        state.platform = val
    },
    SET_ISINNER(state, val) {
        state.isinapp = val
    },
    SET_LOADOVER(state, val) {
        state.loadOver = val
    }
}

const actions = {
    /**
   * 初始化当前所有账户并启动监听
   */
    async init({ commit }) {
        const hasLogin = store.state.user.hasLogin
        if (!hasLogin) return Promise.reject('用户尚未登录')

        // 创建client
        await store.dispatch('wallet/loadClient')

        // 更新账户状态
        try {
            await store.dispatch('wallet/updateAccountCache')
        } catch (error) {
            const eStr = String(error)
            if (eStr.indexOf('WALLET_NEED_SCAN') >= 0) {
                store.dispatch('wallet/walletScan')
            }
            sendErrorLog('[app.js-store.dispatch(wallet/updateAccountCache)]' + error)
        }

        // 扫描账户
        const account = store.state.wallet.account
        // if (!account.lastScan || account.lastScan == 'false') {
        //     store.dispatch('wallet/walletScan')
        // }
        // 开启定时任务
        store.dispatch('app/startTask')
        // 启动监听
        blockEventListener()
        if (
            account.cacheStatus &&
      account.cacheStatus.wallet &&
      account.cacheStatus.wallet.n > 1 &&
      account.cacheStatus.wallet.beRegistered == false
        ) {
            console.log('待注册的多签账户无法更新交易记录')
            return Promise.resolve(99)
        }
        console.log('init over')
        commit('SET_LOADOVER', true)
        return Promise.resolve(1)
    },
    /**
   * 清理定时任务
   */
    clearTask() {
        const intervalIds = store.state.app.intervalIds
        if (intervalIds && intervalIds.length > 0) {
            intervalIds.forEach(i => {
                clearInterval(i)
            })
        }
    },
    /**
   * 定时任务
   */
    startTask({ commit }) {
        return new Promise((resolve, reject) => {
            startTasks()
                .then(intervalIds => {
                    commit('SET_TASK_IDS', intervalIds)
                    return resolve(true)
                })
                .catch(err => {
                  sendErrorLog('[app.js-startTask]' + err)
                    return reject(err)
                })
        })
    },
    /**
   * 选择地址
   */
    updateChoseAddress({ commit }, val) {
        commit('SET_CHOSE', val)
    },
    /**
   * 扫描二维码
   */
    updateScanRes({ commit }, val) {
        commit('SET_SCAN_RES', val)
    },
    /**
   * 配置当前运行环境
   */
    setenvplatform({ commit }, val) {
        commit('SET_PLATFORM', val)
    },
    /**
   * 是否是内嵌钱包
   */
    setisinapp({ commit }, val) {
        commit('SET_ISINNER', val)
    }
}

export default {
    state,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js